import { CardContent as MuiCardContent } from '@mui/material';
import { styled } from '@mui/system';

const CardContent = styled(MuiCardContent)({
  padding: '10px 15px 0',
  flexGrow: 1,
});

export default CardContent;
